;; ##canonical##
(ns kc.impl.base62 
  (:require
    [clojure.string :as str]))
                                                                          
(def base62-chars                                                       
  "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz")     
 
(defn uuid->base62
  "Converts a UUID to a Base62 string, always 22 chars: left-padded with
  zeros, so that every id has the same length and ids sort as text."
  [uuid]
  (let [uuid-str   (if (string? uuid) uuid (str uuid))
        hex        (str/replace uuid-str #"-" "")
        num        (js/BigInt (str "0x" hex))
        base       (js/BigInt 62)]
    (loop [remaining num
           encoded  ""]
      (if (pos? remaining)
        (let [idx (js/Number (js* "BigInt.asUintN(53, ~{} % ~{})"
                                  remaining base))]
          (recur (js* "~{} / ~{}" remaining base)
                 (str (.charAt base62-chars idx) encoded)))
        (.padStart encoded 22 "0")))))                                                  
                                                                              
